import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { CSSTransition } from 'react-transition-group';

import { MOTION_SPEEDS, FADE } from '@wds/helpers';
import useStyles from './useStyles';

const Fade = ({ children, speed, timeout, ...rest }) => {
  const transitionTime = timeout || FADE.speed[speed];
  const classes = useStyles({ transitionTime });
  return (
    <CSSTransition
      className={classes.wrenchFade}
      classNames={{ ...classes }}
      timeout={transitionTime}
      unmountOnExit
      {...safeRest(rest)}
    >
      {children}
    </CSSTransition>
  );
};

Fade.propTypes = {
  /**
   * The component to wrap the transition around
   */
  children: PropTypes.node.isRequired,
  /**
   * Variant speeds of transition
   */
  speed: PropTypes.oneOf(MOTION_SPEEDS),
  /**
   * Define timeout delay of transition
   */
  timeout: PropTypes.number,
};

Fade.defaultProps = {
  speed: 'normal',
  timeout: undefined,
};

export default Fade;
